import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { ExternalLink, Text } from 'roo-ui/components';
import { LUXE_URL } from 'config/constants';
import { luxuryOffersLinkSelected } from 'lib/gaTracking/cancelBookingPageEvents';
import { FormattedNumber } from 'components/Formatters';
import { BonusPointsDisclaimer, CreditVoucherDisclaimer, PointsDisclaimer } from 'components/Disclaimers';

const StyledExternalLink = styled(ExternalLink)`
  color: ${themeGet('colors.brand.primary')} !important;
`;

export interface CreditVoucherRefundMessageProps {
  propertyName: string;
  email: string;
  bonusPoints: string | number;
}

const CreditVoucherRefundMessage = ({ propertyName, email, bonusPoints }: CreditVoucherRefundMessageProps) => (
  <Text fontSize="18px" data-testid="credit-voucher-refund-message">
    Your booking at {propertyName} has been cancelled. You will receive confirmation and your credit voucher details via email to{' '}
    <b>{email}</b>
    <br />
    <br />
    Thank you for choosing a Qantas Hotels credit voucher
    <CreditVoucherDisclaimer.Link /> as your refund option.
    <br />
    <br />
    When you’re ready to use it, you’ll earn 3 Qantas Points per A$1 spent
    <PointsDisclaimer.Link /> or, 6 points per dollar
    <PointsDisclaimer.Link /> if you choose a{' '}
    <StyledExternalLink data-testid="luxury-offer-link" href={LUXE_URL} onClick={luxuryOffersLinkSelected} underline>
      Luxury Offers
    </StyledExternalLink>
    , one of our carefully curated multi-night stays at fantastic destinations, packed with bonus inclusions.
    <br />
    <br />
    In addition, we have awarded you <b>{FormattedNumber({ number: bonusPoints, decimalPlaces: 0 })} bonus Qantas Points</b>
    <BonusPointsDisclaimer.Link /> as a thank you for choosing a credit voucher
    <CreditVoucherDisclaimer.Link />.
    <br />
    <br />
    We hope to see you again soon.
  </Text>
);

export default CreditVoucherRefundMessage;
